var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 347.03,
    height: 297.242,
    viewBox: "0 0 347.03 297.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850",
    transform: "translate(1.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    d: "M635.94,45.626a3.8,3.8,0,1,0,3.8-3.8A3.8,3.8,0,0,0,635.94,45.626Z",
    transform: "translate(-379.009 -13.307)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    d: "M651.452,45.626a3.8,3.8,0,1,0,3.8-3.8A3.8,3.8,0,0,0,651.452,45.626Z",
    transform: "translate(-405.675 -13.307)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M666.958,45.626a3.8,3.8,0,1,0,3.8-3.8A3.8,3.8,0,0,0,666.958,45.626Z",
    transform: "translate(-432.335 -13.307)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M568.043,153.456l9.81-2.305a21.116,21.116,0,0,0,10.686-6.236l2.059-2.233a11.671,11.671,0,0,1,12.5-3.077,5.551,5.551,0,0,1,2.3,8.9l-12.146,12.41a26.881,26.881,0,0,1-14.424,7.65l-10.578-.779a66.007,66.007,0,0,0-35.433,7.336l-8.763,4.582,12.367-25.9Z",
    transform: "translate(-261.788 -40.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M568.043,153.456l9.81-2.305a21.116,21.116,0,0,0,10.686-6.236l2.059-2.233a11.671,11.671,0,0,1,12.5-3.077,5.551,5.551,0,0,1,2.3,8.9l-12.146,12.41a26.881,26.881,0,0,1-14.424,7.65l-10.578-.779a66.007,66.007,0,0,0-35.433,7.336l-8.763,4.582,12.367-25.9Z",
    transform: "translate(-261.788 -40.568)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M570.663,150.39l10.556-4.72a24.224,24.224,0,0,0,10.694-9.34l1.838-2.961a13.392,13.392,0,0,1,13.425-6.172,6.369,6.369,0,0,1,4.513,9.531l-11,16.614a30.843,30.843,0,0,1-14.6,11.741L574,166.493a75.749,75.749,0,0,0-38.344,15.933l-8.883,7.059,8.334-31.862Z",
    transform: "translate(-269.531 -37.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M570.663,150.39l10.556-4.72a24.224,24.224,0,0,0,10.694-9.34l1.838-2.961a13.392,13.392,0,0,1,13.425-6.172,6.369,6.369,0,0,1,4.513,9.531l-11,16.614a30.843,30.843,0,0,1-14.6,11.741L574,166.493a75.749,75.749,0,0,0-38.344,15.933l-8.883,7.059,8.334-31.862Z",
    transform: "translate(-269.531 -37.231)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M626.144,109.813l-65.487.678a21.076,21.076,0,0,1-21.294-20.857l-.677-65.487A21.076,21.076,0,0,1,559.543,2.852l65.487-.678a21.077,21.077,0,0,1,21.294,20.857L647,88.519a21.077,21.077,0,0,1-20.857,21.294",
    transform: "translate(-312.525 -2.173)",
    fill: "#f3c02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M571.7,148.095l9.588-6.464a24.224,24.224,0,0,0,8.93-11.039l1.3-3.233a13.392,13.392,0,0,1,12.165-8.388,6.37,6.37,0,0,1,6.084,8.614l-7.984,18.258a30.845,30.845,0,0,1-12.365,14.075l-37.831,13.446-16.41,20.786,2.735-32.82Z",
    transform: "translate(-273.185 -34.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M571.7,148.095l9.588-6.464a24.224,24.224,0,0,0,8.93-11.039l1.3-3.233a13.392,13.392,0,0,1,12.165-8.388,6.37,6.37,0,0,1,6.084,8.614l-7.984,18.258a30.845,30.845,0,0,1-12.365,14.075l-37.831,13.446-16.41,20.786,2.735-32.82Z",
    transform: "translate(-273.185 -34.965)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M568.079,68.957V59.945l8.014-.684a24.44,24.44,0,0,1,3.14-8.194l-5.363-6.311,6.359-6.388,6.145,5.177a24.479,24.479,0,0,1,8.013-3.565l.674-8.257,9.016-.021.68,8.011a24.38,24.38,0,0,1,8.193,3.14l6.314-5.363,6.387,6.358L620.471,50a24.37,24.37,0,0,1,3.567,8.014l7.943.673v9.011l-7.674.685a24.351,24.351,0,0,1-3.142,8.189l5.365,6.313-6.362,6.385-6.146-5.177A24.334,24.334,0,0,1,606,87.655L605.34,95.6h-9.016l-.687-7.675a24.464,24.464,0,0,1-8.187-3.146l-6.316,5.366-6.389-6.358,5.182-6.147a24.54,24.54,0,0,1-3.57-8.015Zm31.95,9.218a14.523,14.523,0,1,0-14.522-14.523,14.522,14.522,0,0,0,14.522,14.523",
    transform: "translate(-318.644 -10.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M626.009,169.041l9.3,41.026-61.265,5.47-9.9-52.8a18.577,18.577,0,0,1,18.15-21.774l45.905-.37,8.661-7.662a24.219,24.219,0,0,0,7.41-12.111l.868-3.375a13.393,13.393,0,0,1,10.964-9.906,6.369,6.369,0,0,1,7.157,7.745l-5.529,19.145A30.842,30.842,0,0,1,647.309,150l-7.546,6.009",
    transform: "translate(-347.057 -31.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    d: "M626.009,169.041l9.3,41.026-61.265,5.47-9.9-52.8a18.577,18.577,0,0,1,18.15-21.774l45.905-.37,8.661-7.662a24.219,24.219,0,0,0,7.41-12.111l.868-3.375a13.393,13.393,0,0,1,10.964-9.906,6.369,6.369,0,0,1,7.157,7.745l-5.529,19.145A30.842,30.842,0,0,1,647.309,150l-7.546,6.009",
    transform: "translate(-347.057 -31.736)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M579.836,236.317l88.616-11.487,50.873,38.837-2.735-20.786,67.283-3.283,15.206,67.085a34.308,34.308,0,0,1-42.632,40.643L622.5,310.164Z",
    transform: "translate(-495.074 -64.687)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    d: "M926.437,354.483H800.489c-1.833,0-1.151-8.415-1.151-8.415-23.838,0-34.141-17.6-37.382-41.215a47.7,47.7,0,0,1,8.734-34.616l31.5-43.143a51.313,51.313,0,0,1,30.625-19.9L874,198.309l57.921,20.1Z",
    transform: "translate(-757.708 -57.241)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M833.786,135.074,819.5,133.889a30.039,30.039,0,0,1-27.372-32.325l.47-5.659a37.613,37.613,0,0,1,40.475-34.275l1.094,5.789a23.576,23.576,0,0,1,21.484,25.371l-2.12,25.56a18.352,18.352,0,0,1-19.749,16.723",
    transform: "translate(-703.474 -18.83)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M784.346,94.327c-5.914,16.409,3.445,34.845,20.9,41.177s36.406-1.836,42.321-18.246-3.445-34.845-20.9-41.177-36.406,1.836-42.321,18.246",
    transform: "translate(-690.279 -22.322)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M791.073,111.58c1.776-10.637,9.9-19.58,20.144-21.213h0a19.536,19.536,0,0,1,16.657,5.068c-2.85-.775-10.981-2.489-14.418,2.012-4.2,5.505-8.926,17.263-22.385,14.132",
    transform: "translate(-674.925 -26.861)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    d: "M798.357,95.856a15.037,15.037,0,1,1-13.742-16.229,15.037,15.037,0,0,1,13.742,16.229",
    transform: "translate(-629.104 -23.905)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M857.642,67.452a33.853,33.853,0,0,0-32.095,29.794,23.335,23.335,0,0,0,12.577,4.925c12.464,1.034,23.365-7.741,24.349-19.6a20.915,20.915,0,0,0-4.831-15.119",
    transform: "translate(-734.389 -20.501)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    d: "M833.246,78A15.037,15.037,0,1,1,819.5,61.767,15.037,15.037,0,0,1,833.246,78",
    transform: "translate(-689.086 -18.89)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M809.893,80.872a15.466,15.466,0,1,1-14.134-16.691,15.466,15.466,0,0,1,14.134,16.691",
    transform: "translate(-648.323 -19.567)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M856.254,71.727s5.444,1.564,6.369,6.4",
    transform: "translate(-756.554 -21.701)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M855.492,68.289s-1.034,5.569,2.877,8.557",
    transform: "translate(-751.661 -20.736)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M848.536,116.136l-.284-2.566a23.366,23.366,0,0,0-25.791-20.66h0a23.377,23.377,0,0,0-20.568,19.9,9.409,9.409,0,0,0-6.3,16.949l-16.46,43.33-10.58,3.629c-.28,8.866,4.022,19.029,12.331,27.019,13.2,12.7,31.5,15.092,40.863,5.353,7.327-7.618,6.99-20.4.191-31.682l-4.036-1.155,5.893-15.511a23.3,23.3,0,0,0,26.839-25.631l-.988-8.947a5.083,5.083,0,0,0,3.97-5.474h0a5.081,5.081,0,0,0-5.077-4.55",
    transform: "translate(-684.483 -27.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    d: "M848.536,116.136l-.284-2.566a23.366,23.366,0,0,0-25.791-20.66h0a23.377,23.377,0,0,0-20.568,19.9,9.409,9.409,0,0,0-6.3,16.949l-16.46,43.33-10.58,3.629c-.28,8.866,4.022,19.029,12.331,27.019,13.2,12.7,31.5,15.092,40.863,5.353,7.327-7.618,6.99-20.4.191-31.682l-4.036-1.155,5.893-15.511a23.3,23.3,0,0,0,26.839-25.631l-.988-8.947a5.083,5.083,0,0,0,3.97-5.474h0A5.081,5.081,0,0,0,848.536,116.136Z",
    transform: "translate(-684.483 -27.608)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    "data-name": "Path 3225",
    d: "M852.159,141.939a9.416,9.416,0,0,1-6.6-11.565",
    transform: "translate(-738.156 -38.167)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    d: "M840.365,129.559a5.913,5.913,0,0,1,2.747,5.828",
    transform: "translate(-725.68 -37.938)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M788.888,142.225s-4.019,1.976-7-3.293",
    transform: "translate(-629.33 -40.57)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M787.832,124.485a2,2,0,1,1-1.846-2.462,2.2,2.2,0,0,1,1.846,2.462",
    transform: "translate(-629.733 -35.822)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    d: "M794.2,113.895c.336.748-1.07,2.108-3.141,3.039s-4.022,1.079-4.358.331,1.07-2.108,3.141-3.039,4.022-1.079,4.358-.331",
    transform: "translate(-638.118 -33.407)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M839.351,94.429a19.434,19.434,0,0,0-19.926,15.33,13.394,13.394,0,0,0,6.928,3.482c7.07,1.252,13.767-3.186,14.958-9.913a12.005,12.005,0,0,0-1.96-8.9",
    transform: "translate(-708.935 -28.069)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    "data-name": "Path 3231",
    d: "M828.63,179.46a23.377,23.377,0,0,1-19.073-20.436",
    transform: "translate(-688.975 -46.211)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    d: "M811.18,168.446a30.054,30.054,0,0,1-1.268-2.727A30.468,30.468,0,0,0,823.51,192l3.582-9.428a30.445,30.445,0,0,1-15.912-14.124",
    transform: "translate(-687.682 -48.091)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    y1: 12.531,
    x2: 35.309,
    transform: "translate(19.361 212.465)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    x1: 1.231,
    y2: 25.847,
    transform: "translate(169.959 230.981)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    x1: 8.37,
    y1: 49.924,
    transform: "translate(225.125 177.437)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    "data-name": "Path 3233",
    d: "M681.339,280.079s41.571-17.5,60.985-26.554S793.8,238.8,793.8,238.8c32.634-8.665,61.494,1.239,62.708,1.664a8.376,8.376,0,0,1-5.531,15.812,76.544,76.544,0,0,0-8.953-2.243,66.547,66.547,0,0,1,15.973,11.53,8.376,8.376,0,0,1-12.131,11.552,40.9,40.9,0,0,0-4.4-3.666,48.643,48.643,0,0,1,3.6,4.5,8.376,8.376,0,0,1-13.887,9.368c-.093-.137-8.591-12.231-25.751-18.922,12.946,6.341,19.053,15.227,19.389,15.728a8.377,8.377,0,0,1-13.868,9.4c-.233-.334-4.592-6.4-14.028-10.639-6.244,10.133-21.83,8.716-21.83,8.716s-55.707,54.607-59.222,54.11-17.594.18-32.052-20.111c-15.078-21.162-2.467-45.515-2.467-45.515",
    transform: "translate(-626.669 -67.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    "data-name": "Path 3234",
    d: "M681.339,280.079s41.571-17.5,60.985-26.554S793.8,238.8,793.8,238.8c32.634-8.665,61.494,1.239,62.708,1.664a8.376,8.376,0,0,1-5.531,15.812,76.544,76.544,0,0,0-8.953-2.243,66.547,66.547,0,0,1,15.973,11.53,8.376,8.376,0,0,1-12.131,11.552,40.9,40.9,0,0,0-4.4-3.666,48.643,48.643,0,0,1,3.6,4.5,8.376,8.376,0,0,1-13.887,9.368c-.093-.137-8.591-12.231-25.751-18.922,12.946,6.341,19.053,15.227,19.389,15.728a8.377,8.377,0,0,1-13.868,9.4c-.233-.334-4.592-6.4-14.028-10.639-6.244,10.133-21.83,8.716-21.83,8.716s-55.707,54.607-59.222,54.11-17.594.18-32.052-20.111C668.728,304.432,681.339,280.079,681.339,280.079Z",
    transform: "translate(-626.669 -67.614)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    "data-name": "Path 3235",
    d: "M704.315,246.209s16.673,4.01,26.306,10.9",
    transform: "translate(-515.271 -70.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    "data-name": "Path 3236",
    d: "M704.315,246.209s16.673,4.01,26.306,10.9",
    transform: "translate(-515.271 -70.689)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    "data-name": "Path 3237",
    d: "M705.1,261.305s17.992,6.8,28.45,19.455",
    transform: "translate(-518.759 -74.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    "data-name": "Path 3238",
    d: "M705.1,261.305s17.992,6.8,28.45,19.455",
    transform: "translate(-518.759 -74.928)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    "data-name": "Path 3239",
    d: "M946.623,159.852a40.32,40.32,0,0,0,1.882-55.01l-8.23,8.23A28.724,28.724,0,0,1,899.839,153.5l-8.23,8.232a40.325,40.325,0,0,0,55.014-1.884",
    transform: "translate(-877.793 -30.999)",
    fill: "#ffd23d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    d: "M934.35,95.941A40,40,0,0,0,910.268,85.75V97.392a28.49,28.49,0,0,1,15.863,6.766Z",
    transform: "translate(-867.13 -25.638)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    d: "M969.155,144.652A28.751,28.751,0,0,1,983.1,98.322a27.87,27.87,0,0,1,5.733-1V85.7a40.316,40.316,0,0,0-27.893,67.175Z",
    transform: "translate(-950.661 -25.625)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPicture);
export default __webpack_public_path__ + "static/media/form_picture.0fd985035934f74c419a54ef876af4c1.svg";
export { ForwardRef as ReactComponent };